import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { AppBar, Tabs, Tab, Box } from '@mui/material'
import Grid from '@mui/material/Grid';
import NavigationButtons from '../container/NavigationButtons';
import Flag from 'react-world-flags'
import MDTextField from './custom/MDTextField';
import AsyncReactSelect from './custom/AsyncReactSelect';

function TabContainer({ children }) {
  return (
    <Box sx={{ p: 2 }}>
      {children}
    </Box>
  );
}

function ExportImport(props) {
  const dispatch = useDispatch()
  // const start = useSelector((state) => state.start)
  // const activeStep = useSelector((state) => state.activeStep)
  const initialExportImport = useSelector((state) => state.exportImport)
  // const person = useSelector((state) => state.person)
  // const addresses = useSelector((state) => state.addresses)

  // const [activeStep, setActiveStep] = useState(props.activeStep);
  const [exportImport, setExportImport] = useState(initialExportImport);
  const [updatePerson, setUpdatePerson] = useState(props.updatePerson);
  const [value, setValue] = useState(exportImport.exportOrImport === -1? 0 : exportImport.exportOrImport);
  const [uniqId, setUniqId] = useState(props.uniqId);

  const [onUSA, setOnUSA] = useState(true);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const [requiredFields, setRequiredFields] = useState({departureCountry: false, departurePort: false, arriveCountry: false, arrivePort: false });

  const { locator } = props

    useEffect(() => {
      setExportImport(initialExportImport)
    }, [initialExportImport])
  // useEffect(() => {
  //   if (props.activeStep === 4) {
  //     setActiveStep(props.activeStep)
  //     setExportImport(props.exportImport)
  //   }
  // }, [props.exportImport])

  const handleChange = (propertyName, value) => {  
    const newExportImport = {
      ...exportImport,
      [propertyName]: value,
    }; 
    setExportImport(newExportImport)
    // dispatch(updateExportImport(newExportImport))
    
    let letter = /^[A-Za-z]+$/;
    let arriveCityPort = newExportImport.arrivePort.match(letter)? newExportImport.arrivePort.toUpperCase(): newExportImport.arrivePort;
    let DepartCityPort = newExportImport.departurePort.match(letter)? newExportImport.departurePort.toUpperCase(): newExportImport.departurePort
    if(newExportImport.departurePort !=='' && newExportImport.arrivePort !=='' && arriveCityPort ===  DepartCityPort) {
      setError(true)
      setErrorText('Arrival and Departure City/Port cannot be same')
    } else {
      setError(false)
      setErrorText('')
    }
  }

  const handleTabChange = (event, value) => {
    setError(false)
    setErrorText('')

    const newExportImport = {
      ...exportImport,
      exportOrImport: value,
      departurePort: "",
      arrivePort:"",
      departureCountry: value === 1? {
        value: 'USA',
        label: [<Flag code='USA' height="12" />, ' ',  'UNITED STATES'],      
        countryDescription: 'UNITED STATES'
      } : "",
      arriveCountry: value === 0? {
        value: 'USA',
        label: [<Flag code='USA' height="12" />, ' ',  'UNITED STATES'],      
        countryDescription: 'UNITED STATES'
      } : "",    

    };
    
    setValue(value)
    // dispatch(updateExportImport(newExportImport))
    setExportImport(newExportImport)
  };

  const handleError = (propertyName, error) => {
    const newRequiredFields = {
      ...requiredFields,
      [propertyName]: !error,      
    };
    
    setRequiredFields(newRequiredFields)
  }

  return (
    <div>
              <Grid>
                <AppBar position="relative" color="inherit" sx={{
                  padding: 2,
                  textAlign: 'left',
                  justifyContent: 'center',
                  color: 'text.primary',
                  backgroundColor: '#ffffff',
                }} >
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="black"
                    variant="fullWidth"
                  >
                    <Tab sx={{
                      minHeight: '30px',
                      backgroundColor: (value === -1 || value === 0) ? "#4D95A3" : "#D1D6D7",
                      fontWeight: (value === -1 || value === 0) ? "760" : "normal"
                    }} label="Import" />
                    <Tab sx={{
                      minHeight: '30px',
                      backgroundColor: value === 1 ? "#4D95A3" : "#D1D6D7",
                      fontWeight: value === 1 ? "760" : "normal"
                    }} label="Export" />
                  </Tabs>
                
                {(value === -1 || value === 0) && 
                <TabContainer>
                  <Grid container sx={{ alignItems: 'center', flexDirection: 'row' }}>
                    <AsyncReactSelect name='departureCountry' label='Departure Country'  value={exportImport.departureCountry} 
                        optionsType='country' placeholder='Search for Country' errorText='Please select country' onUSA={onUSA} handleChange={handleChange} handleError={handleError} uniqId={locator==='Review'?'departureCountry'+locator:'departureCountry'}  required={true} />
                    <MDTextField name='departurePort' label='Departure City/Port' value={exportImport.departurePort} handleChange={handleChange} handleError={handleError} required={true} inputProps={{maxLength: 50, id:locator==='Review'?'departurePort'+locator:'departurePort'}} />                      
                  </Grid>
                  <Grid container sx={{ alignItems: 'center', flexDirection: 'row' }}>  
                    <AsyncReactSelect name='arriveCountry' label='Arrival Country' value={exportImport.arriveCountry} optionsType='country' uniqId={locator==='Review'?'arriveCountry'+locator:'arriveCountry'}  summary={true} />
                    <MDTextField name='arrivePort' label='Arrival City/Port' value={exportImport.arrivePort} handleChange={handleChange} handleError={handleError} error={error} errorText={errorText} required={true} inputProps={{maxLength: 50, id:locator==='Review'?'arrivePort'+locator:'arrivePort'}} />                      
                  </Grid>
                </TabContainer>}

                {(value === 1) &&                   
                <TabContainer>
                  <Grid container sx={{ justifyContent: 'flex-end', alignItems: 'center', flexDirection: 'row' }}>                      
                    <AsyncReactSelect name='departureCountry' label='Departure Country' value={exportImport.departureCountry} optionsType='country' uniqId={locator==='Review'?'departureCountry'+locator:'departureCountry'}  summary={true} />
                    <MDTextField name='departurePort' label='Departure City/Port' value={exportImport.departurePort} handleChange={handleChange} handleError={handleError} required={true}  inputProps={{maxLength: 50, id:locator==='Review'?'departurePort'+locator:'departurePort'}} />                      
                  </Grid>
                  <Grid container sx={{ justifyContent: 'flex-end', alignItems: 'center', flexDirection: 'row' }}>                      
                    <AsyncReactSelect name='arriveCountry' label='Arrival Country'   value={exportImport.arriveCountry} 
                        optionsType='country' placeholder='Search for Country' errorText='Please select country' onUSA={onUSA} handleChange={handleChange} handleError={handleError}  uniqId={locator==='Review'?'arriveCountry'+locator:'arriveCountry'}  required={true} inputProps={{maxLength: 50, id:locator==='Review'?'arrivePort'+locator:'arrivePort'}} />
                    <MDTextField name='arrivePort' label='Arrival City/Port' value={exportImport.arrivePort} handleChange={handleChange} handleError={handleError} error={error} errorText={errorText} required={true} />                      
                  </Grid>
                </TabContainer>}
              </AppBar>                  
            </Grid>

            <NavigationButtons exportImport={exportImport} 
                  allReqDone={(value === 0? requiredFields.departureCountry : true) && requiredFields.departurePort &&
                  (value === 1? requiredFields.arriveCountry : true) && requiredFields.arrivePort && !error} />              
      </div>
  );
}

export default ExportImport;